// @ts-nocheck
import React, { ReactNode } from "react";
import { StylesProvider } from "@mui/styles";

type StyleSettingsProps = {
  children: ReactNode;
  generateClassName: Function;
};

const StyleSettings = (props: StyleSettingsProps) => {
  const { children, generateClassName } = props;
  return <StylesProvider generateClassName={generateClassName}>{children}</StylesProvider>;
};

export default StyleSettings;
